/**
 * *****************************************************
 * ╔╦╗╔═╗  ╔╗╔╔═╗╔╦╗  ╔╦╗╔═╗╔╦╗╦╔═╗╦ ╦  ╔═╗╔╦╗╔═╗╔╦╗╔═╗┬
 *  ║║║ ║  ║║║║ ║ ║   ║║║║ ║ ║║║╠╣ ╚╦╝  ╚═╗ ║ ╠═╣ ║ ║╣ │
 * ═╩╝╚═╝  ╝╚╝╚═╝ ╩   ╩ ╩╚═╝═╩╝╩╚   ╩   ╚═╝ ╩ ╩ ╩ ╩ ╚═╝o
 * ALWAYS RETURN A COPY
 * *****************************************************
 */

import { LEASE_FILTER as LEASE_ACTION_CONSTANTS } from '../actions/constants';
import { LEASE_FILTER as LEASE_SELECTOR_CONSTANTS } from '../selectors/constants';

/**
 * [offers description]
 * @param  {[type]} state  =             [] [description]
 * @param  {[type]} action [description]
 * @return {[type]}        [description]
 */
export default function leaseFilter(state = [], action) {
  switch (action.type) {
    case LEASE_ACTION_CONSTANTS.GET_LEASE_FILTER: {
      const leaseFilterData = action.data;

      leaseFilterData.forEach((filter) => {
        if (filter.filtermaximumnumber !== null
          && filter.filterminimumnumber !== null) {
          filter.type = LEASE_SELECTOR_CONSTANTS.TYPES.BETWEEN;
        } else if (filter.filtermaximumnumber !== null
          && filter.filterminimumnumber === null) {
          filter.type = LEASE_SELECTOR_CONSTANTS.TYPES.LESS;
        } else if (filter.filtermaximumnumber === null
          && filter.filterminimumnumber !== null) {
          filter.type = LEASE_SELECTOR_CONSTANTS.TYPES.MORE;
        }
      });

      return leaseFilterData;
    }
    case LEASE_ACTION_CONSTANTS.FILTER_SELECTED: {
      const newState = [...state];

      newState.forEach((filter) => {
        filter.selected = false;
      });

      const selectedLeaseFilter = newState[action.data.filter];

      selectedLeaseFilter.selected = true;

      return newState;
    }
    default:
      return state;
  }
}
